<template>
  <div>
    <div slot="title">
      <h2>Nueva Estructura Orgánica</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" id="Formulario" style="margin-top:30px;">
          <div class="col-12">
            <div class="row">
              <div class="col-6">
                <C001Area id="entidadDeDomicioDelFamiliarId"
                          :prefijo="enumeraciones.etiquetasDeHTML.Select"
                          :tipo="enumeraciones.tiposDeSelect.Seleccione"
                          :local="{Id: datosLocales[0].Id, valor: datosLocales[0].valor.Id}"
                          v-on:valorParaElPadre="getValorEntidad"
                          idDelInput="Area"></C001Area>
              </div>
              <div class="col-6">
                <C039TiposDepartamento id="TiposDepartamentosCombo"
                                       :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                       :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                       :local="{Id: datosLocales[1].Id, valor: datosLocales[1].valor}"
                                       v-on:valorParaElPadre="getValorMunicipio"
                                       :hereda="datosLocales[0].valor.Id"
                                       :key="datosLocales[0].valor.Id"></C039TiposDepartamento>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <C003TipoTurno id="" :prefijo="enumeraciones.etiquetasDeHTML.Select"
                               :tipo="enumeraciones.tiposDeSelect.Seleccione"
                               :idDelInput="'NuevaEstructuraOrganica_TipoTurno_Laboral'"
                               :local="{Id: datosLocales[2].Id, valor: datosLocales[2].valor}"
                               v-on:datosPadre="getValorHijo"
                               ></C003TipoTurno>
              </div>
              <div class="col-6">
                <C045Puestos id="" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione"></C045Puestos>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <C028TipoPlaza id=""
                               :prefijo="enumeraciones.etiquetasDeHTML.Select"
                               :tipo="enumeraciones.tiposDeSelect.Seleccione"
                               :idDelInput="'NuevaEstructuraOrganica_TipoPlaza_Laboral'"
                               :local="{Id: datosLocales[3].Id, valor: datosLocales[3].valor}"
                               v-on:datosPadre="getValorHijo"></C028TipoPlaza>
              </div>

            </div>
            <div class="row" style="margin-top:20px;">
              <div class="col-6">
              </div>
              <div class="col-6">
                <input type="button" value="Guardar" class="form-control" v-bind:disabled="deshabilitarBotonGuardar" @click="guardarEstructura">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import store from '@/store/index'
  import catalogos from "@/../static/js/catalogos";
  export default {
    data() {
      return {
        activo: true,
        enumeraciones,
        datosLocales: [
          {
            Id: 0,
            key: "area",
            valor: { Id: -1, nombre: null }
          },
          {
            Id: 1,
            key: "departamento",
            valor: { Id: -1, nombre: null }
          },
          {
            Id: 2,
            key: "turno",
            valor: { Id: -1, nombre: null }
          },
          {
            Id: 3,
            key: "plaza",
            valor: { Id: -1, nombre: null }
          }
        ],
        tipoTurno: -1,
        tipoPlaza: -1
      }
    },
    components: {
      C001Area: catalogos.PJ.C001Area,
      C039TiposDepartamento: catalogos.PJ.C039TipoDepartamento,
      C003TipoTurno: catalogos.SIAP.C003TipoTurno,
      C045Puestos: catalogos.PJ.C045Puestos,
      C028TipoPlaza: catalogos.SIAP.C028TipoPlaza
    },
    methods: {
      getValorEntidad(respuestaHijo) {
        this.datosLocales[0].valor = {
          Id: parseInt(respuestaHijo.target.value),
          nombre: respuestaHijo.target.options[respuestaHijo.target.selectedIndex].text
        };
        this.datosLocales[1].valor = {
          Id: -1,
          nombre: null
        };
      },
      getValorMunicipio(respuestaHijo) {
        this.datosLocales[1].valor = {
          Id: parseInt(respuestaHijo.target.value),
          nombre: respuestaHijo.target.options[respuestaHijo.target.selectedIndex].text
        };
      },
      getValorHijo(respuestaHijo) {
        console.log(respuestaHijo)
        var sel = respuestaHijo.valor.target
        this.datosLocales[respuestaHijo.Id].valor = {
          Id: parseInt(sel.value),
          nombre: sel.options[sel.selectedIndex].text
        }
      },
      validar: function (val) {
        return val == -1
      },validarArray: function (array,llave) {
        return array[llave] == -1 || array[llave] == "-1"
      },
      guardarEstructura: function () {
        var peticion = {//Carga los valores para enviar la petición de busqueda
          "esPrueba": false,
          "DepartamentoId": this.datosLocales[1].valor.Id,
          "AreaId": this.datosLocales[0].valor.Id,
          "TipoTurnoId": this.datosLocales[2].valor.Id,
          "PuestoDBPJ": this.$store.getters.Get_PJ_Catalogos_045Puestos,
          "Activo": this.activo,
          "TipoPlazaId": this.datosLocales[3].valor.Id
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIAP.funcion.GuardarEstructuraOrganica, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {

          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }
    },
    computed: {
      deshabilitarBotonGuardar: function () {
        return this.validar(this.datosLocales[0].valor.Id) ||
          this.validar(this.datosLocales[1].valor.Id) ||
          this.validar(this.datosLocales[2].valor.Id) ||
          this.validar(parseInt(this.$store.getters.Get_PJ_Catalogos_045Puestos)) ||
          this.validar(this.datosLocales[3].valor.Id)
      },
      actualizarDepartamento: function () {
        datosLocales[1].valor.Id = 0
        return this.datosLocales[0].valor.Id
      },
      tipoTurnoComputed: function () {
        return this.$store.getters.Get_SIAP_Catalogos_003TipoTurno
      },
      tipoPlazaComputed: function () {
        return this.$store.getters.Get_SIAP_Catalogos_028TipoPlaza
      }
    },
    mounted: function () {
    }
  }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SIAP/AdministracionPersonal/NuevaEstructuraOrganica.vue